{
  "page": {
    "title": "Dashboard",
    "refresh": "Refresh",
    "refreshAriaLabel": "Refresh data",
    "loading": "Loading..."
  },
  "filters": {
    "allEmployees": "All employees",
    "employee": "Employee",
    "timeRange": "Time range",
    "from": "From",
    "to": "To",
    "ranges": {
      "today": "Today",
      "thisWeek": "This week",
      "thisMonth": "This month",
      "custom": "Custom"
    },
    "filteredByCard": "Filtered by: {{label}}",
    "employeesShown": "{{count}} employees",
    "clearFilter": "Clear filter"
  },
  "kpi": {
    "activeEmployees": "Active employees",
    "onSiteNow": "At work now",
    "onSiteNowHint": "Employees whose entry today has no matching exit yet.",
    "totalWork": "Total work",
    "totalBreak": "Total break",
    "totalOvertime": "Total overtime",
    "totalPayroll": "Total payroll",
    "lateCount": "Late count",
    "absentCount": "Absent count",
    "punctuality": "Punctuality",
    "ofTotal": "{{n}} of {{total}} employees",
    "ofPresent": "{{n}} of {{total}} present days",
    "failedToLoad": "Failed to load KPI data.",
    "ariaUpVsPrevious": "Up {{value}}% vs previous period",
    "ariaDownVsPrevious": "Down {{value}}% vs previous period",
    "onLeave": "On leave",
    "absent": "Absent"
  },
  "charts": {
    "workHoursTrend": "Work hours trend",
    "punchHeatmap": "Punch heatmap (hour of day)",
    "failedToLoadTrend": "Failed to load trend data.",
    "noTrendData": "No trend data for this period.",
    "noPunchData": "No punch data for this period.",
    "heatmapLess": "Less",
    "heatmapMore": "More",
    "days": {
      "mon": "Mon",
      "tue": "Tue",
      "wed": "Wed",
      "thu": "Thu",
      "fri": "Fri",
      "sat": "Sat",
      "sun": "Sun"
    }
  },
  "workHoursTable": {
    "title": "Work hours over selected period",
    "subtitle": "Totals over selected period — click a row to drill into employee details.",
    "noData": "No work hours data for the selected period",
    "noDataHint": "Adjust the filters or wait for device data to sync",
    "noEmployeesInFilter": "No employees match this metric",
    "failedToLoad": "Failed to load work hours data. Please try again.",
    "columns": {
      "employee": "Employee",
      "days": "Days",
      "work": "Work",
      "break": "Break",
      "afterHours": "After-hours",
      "lateDeduction": "Late deduction ({{currency}})",
      "totalPay": "Total pay ({{currency}})"
    }
  },
  "employeePage": {
    "backToDashboard": "Back to dashboard",
    "payslipLabel": "Payslip:",
    "noProfession": "No profession assigned",
    "noProfessionHint": "— payroll fields will show 0. Assign pay rates in the Employees page.",
    "workHoursOverTime": "Work hours over time",
    "noDataForPeriod": "No data for the selected period.",
    "dailyBreakdown": "Daily breakdown",
    "noDailyRecords": "No daily records in this period.",
    "failedToLoad": "Failed to load employee data",
    "failedToLoadHint": "Please try refreshing the page.",
    "notFound": "Employee not found or you don't have access.",
    "columns": {
      "date": "Date",
      "firstIn": "First In",
      "lastOut": "Last Out",
      "work": "Work",
      "break": "Break",
      "afterHours": "After-hours",
      "punches": "Punches",
      "mode": "Mode",
      "status": "Status",
      "hourlyPay": "Hourly pay",
      "afterHoursPay": "After-hours pay",
      "salaryShare": "Salary share",
      "lateDeduction": "Late deduction",
      "totalPay": "Total pay"
    },
    "badges": {
      "statusCodes": "Status codes",
      "alternating": "Alternating",
      "unpaired": "Unpaired",
      "downloadPayslip": "Download payslip as {{fmt}}",
      "autoClosed": "Exit auto-filled at end of shift"
    }
  }
}
